import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {iif, Observable, of} from 'rxjs';
import {
  map,
    mergeMap,
} from 'rxjs/operators';
import { AuthGuard } from '@pcscol-portail/ng-auth';
import { TraitementsGuard } from './traitements.guard';

/**
 * Guard à utiliser sur les pages pour les protéger avec l'autorisation
 */
@Injectable({
    providedIn: 'root',
})
export class AuthzGuard  {
    auth = inject(AuthGuard);
    authz = inject(TraitementsGuard);


    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return (this.auth.canActivate(route, state) as Observable<boolean>)
            .pipe(
                mergeMap(authOk => iif(() => authOk, this.authz.canActivate(route, state) as Observable<boolean>, of(false))),
            );
    }
}
